module.exports = __webpack_public_path__ + "static/media/Rectangle 90.77e923ed.png";